import React, { useEffect, useState } from 'react'
import ButtonWithLoader from './ButtonWithLoader'
import SelectWithIcons, { Option } from './SelectWithIcons'
import Microphone from '../icons/Microphone'
import Camera from '../icons/Camera'
import { useDispatch } from 'react-redux'
import { SET_SELECTED_DEVICES as TUTOR_SET_SELECTED_DEVICES } from '../redux/tutorChannelReducer'

interface Props {
  closeModal: () => void
  type: 'tutor' | 'student'
}

const ChoseDeviceModal = ({ closeModal, type }: Props) => {
  const action = TUTOR_SET_SELECTED_DEVICES
  const dispatch = useDispatch()
  useEffect(() => {
    const fetchDevices = async () => {
      const deviceInfos = await navigator.mediaDevices.enumerateDevices()
      const cameraOptions = deviceInfos
        .filter((item) => item.kind === 'videoinput')
        .map((item) => ({ value: item.deviceId, label: item.label }))
      setSelectedCamera(cameraOptions[0]?.value ?? '')
      setCameraOptions(cameraOptions)
      const microphoneOptions = deviceInfos
        .filter((item) => item.kind === 'audioinput')
        .map((item) => ({ value: item.deviceId, label: item.label }))
      setMicrophoneOptions(microphoneOptions)
      setSelectedMicrophone(microphoneOptions[0]?.value ?? '')
    }
    fetchDevices()
  }, [])

  const [selectedCamera, setSelectedCamera] = useState('')
  const [cameraOptions, setCameraOptions] = useState<Option[]>([])
  const [selectedMicrophone, setSelectedMicrophone] = useState('')
  const [microphoneOptions, setMicrophoneOptions] = useState<Option[]>([])

  const handleChoseButtonClick = () => {
    dispatch(action({ cameraId: selectedCamera, microphoneId: selectedMicrophone }))
    closeModal()
  }

  return (
    <div className="max-w-[26rem] bg-slateGray flex-1 mt-20 rounded-lg h-fit p-10">
      <p className="text-white text-22 text-center">Chose preferred microphone and camera</p>
      <div className="h-5" />
      <div className="h-5" />
      <SelectWithIcons
        icon={<Microphone />}
        onChange={(val) => {
          setSelectedMicrophone(val)
        }}
        value={selectedMicrophone}
        options={microphoneOptions}
      />
      <div className="h-5" />
      <SelectWithIcons
        icon={<Camera />}
        onChange={(val) => {
          setSelectedCamera(val)
        }}
        value={selectedCamera}
        options={cameraOptions}
      />
      <div className="h-5" />
      <div className="h-5" />
      <ButtonWithLoader onClick={handleChoseButtonClick} label="Chose" />
    </div>
  )
}

export default ChoseDeviceModal
